import { CreateRoleDocument, CreateRoleMutation } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

const useCreateRole = () => {
  const [mutate, { loading }] = useMutation(CreateRoleDocument, {
    extractorFn: (data: CreateRoleMutation) => data.jobCatalogMutations.createJobcatalogRole,
  })

  const createLevel = (name: string, companyId: string, legalEntityId: string) => {
    return mutate({ variables: { name, companyId, legalEntityIds: [legalEntityId] } })
  }

  return [createLevel, loading] as const
}

export default useCreateRole
